var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg021DriverFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 33",
    style: {
      enableBackground: "new 0 0 35 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF3F37;}\n\t.st1{fill:#EF4036;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.32,16.3c-4.11-3.84-0.36-10.19-0.36-10.19c-1.45-1.59-3.54-2.43-5.68-2.35c-4.19,0.15-7.44,3.72-7.3,7.91 c0.25,7.15,12.69,16.84,13.28,17.23c0.17,0.16,0.33,0.15,0.5,0.15C16.76,29.04,20.43,20.14,16.32,16.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,4.24c-2.13-0.22-4.26,0.48-5.82,1.97c0,0-4.59,5.79-1.03,10.15c3.56,4.36-1.28,12.69-1.28,12.69 c0.16,0.02,0.42-0.04,0.51-0.11c0.61-0.35,13.67-9.28,14.39-16.32C32.08,8.44,29.07,4.66,24.9,4.24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg021DriverFavorite);
export default __webpack_public_path__ + "static/media/021-driver-favorite.54dd65f0e2bb6d26f16850bcde34c5ff.svg";
export { ForwardRef as ReactComponent };